module.exports = "<div class=\"col-xs-12 col-sm-12 no-padding container\">\n    <div class=\"col-xs-12 col-sm-12 no-padding\">\n        <a href=\"/termsAndConditions\">Terms & Conditions</a>\n      </div>\n      <div class=\"col-xs-12 col-sm-12 no-padding\">\n        <a href=\"/privacyPolicy\">Privacy Policy</a>\n      </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/app-footer/app-footer.component.html
// module id = ./src/app/app-footer/app-footer.component.html
// module chunks = main